import { MatDialogConfig } from '@angular/material/dialog';
import { GameSearchModalData } from './game-search.model';

export const GAME_SEARCH_DIALOG_CONFIG: MatDialogConfig<GameSearchModalData> = {
  width: '600px',
  maxWidth: '95vw',
  panelClass: ['no-padding-container', 'no-default-background-dialog-shadow'],
  autoFocus: 'input',
};
